/**
 * @desc: 人工复核
 * @created: 2020/4/30
 * @author: Colorfule
 * @version: v1.0
 */

import * as Models from '@/api/T3/acceptReview'

export default {
  namespaced: true,
  state: {
    checkoutListData: []
  },
  getters: {
    checkoutListData: state => state.checkoutListData
  },
  actions: {
    // 受理复核列表数据
    async getListData(ctx, payload) {
      const res = await Models.getListData(payload)
      return res && res.status === 200 && res.data || {}
    },
    // 获取供应商信息
    async getSupplierDetail(ctx, payload) {
      const res = await Models.getSupplierDetail(payload)
      return res && res.status === 200 && res.data || {}
    },

    // 企业工商信息(企业情况)
    async getCompanyInfo(ctx, payload) {
      const res = await Models.getCompanyInfo(payload)
      return res && res.status === 200 && res.data || {}
    },

    // 获取负责人信息数据
    async getPrincipalInfo(ctx, payload) {
      const res = await Models.getPrincipalInfo(payload)
      return res && res.status === 200 && res.data || []
    },

    // 受理复核 审核
    async transferToRegistered(ctx, payload) {
      const res = await Models.transferToRegistered(payload)
      return res
    },

    // 批量通过
    async auditOpinionList(ctx, payload) {
      const res = await Models.auditOpinionList(payload)
      return (res && res.status === 200 && res.data) || {}
    },

    // 详情 => 历史记录
    async supplierHistory(ctx, payload) {
      const res = await Models.supplierHistory(payload)
      return (res && res.status === 200 && res.data) || {}
    },

    // 疑似关联
    async getSuspectedAssociationInfo(ctx, payload) {
      const res = await Models.getSuspectedAssociationInfo(payload)
      return (res && res.status === 200 && res.data) || {}
    },
  },
  mutations: {
    setCheckoutListData: (state, data) => {
      state.checkoutListData = data;
    }
  }
}
